import axios from "axios";
import { store } from "../_store";
import { logout } from "../_store/_reducers/auth";
import { removeData } from "../_store/_reducers/user";
import { removePrinterData } from "../_store/_reducers/printer";
import { resetEvents } from "../_store/_reducers/eventList";
import { removeKioskData } from "../_store/_reducers/kiosk";
import toast from "react-hot-toast";

const API_URL = process.env.REACT_APP_API_URL;
const ZEBRA_API_URL = process.env.REACT_APP_ZEBRA_API_URL ?? "https://api.zebra.com";
const ZEBRA_API_KEY = process.env.REACT_APP_ZEBRA_API_KEY ?? "6l0C8DfouOHQexQpo3fSESp216jFdMGV";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let isAlertOpen = false;

axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth.token;

    if (token && !config.isZebra) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    
    if (config.isZebra) {
      config.baseURL = ZEBRA_API_URL;
      config.headers["Content-Type"] = "multipart/form-data";
      config.headers["Accept"] = "text/plain";
      config.headers["apikey"] = ZEBRA_API_KEY;
      config.headers["tenant"] = config.tenant;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!isAlertOpen) {
        isAlertOpen = true;

        const message =
          "Your session has expired due to login on another device. Please log in again.";
        // window.alert("Session Expired\n" + message);
        toast.error("Session Expired\n" + message);
        localStorage.clear();
        store.dispatch(logout());
        store.dispatch(removeData());
        store.dispatch(removePrinterData());
        store.dispatch(removeKioskData());
        store.dispatch(resetEvents());

        setTimeout(() => {
          isAlertOpen = false;
        }, 1000);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
